import { format } from 'date-fns';
import { sortBy } from 'lodash';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, inject, Modal, ModalHandle, NothingHere } from 'Mri.Web.Common';
import * as React from 'react';
import { BsCardHeading } from '@react-icons/all-files/bs/BsCardHeading';
import { BsFileEarmark } from '@react-icons/all-files/bs/BsFileEarmark';
import { AppStore } from '../Core/AppStore';
import { PartsStore } from './PartsStore';

export interface IPartTagDataModalParams {
    partGuid: string;
    readonly modalHandle: ModalHandle;
}

@autoinject
@observer
export class PartTagDataModal extends React.Component<IPartTagDataModalParams> {
    public render() {
        return (
            <Modal
                title={this.title}
                size="md"
                modalHandle={this.props.modalHandle}
                footer={this.footer}
                bodyClass="p-0 vh-50"
                onOpened={this.loadTagData}
            >
                <div className="container-fluid p-0">
                    <div className="col-12 overflow">
                        <div>
                            <table className="table table-sm">
                                <thead>
                                    <tr>
                                        <th scope="col">Name</th>
                                        <th scope="col">Value</th>
                                        <th scope="col">Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.tagDatas?.map(tagData => (
                                        <tr key={`${tagData.partTagDatumGuid}`}>
                                            <td>{tagData.partTagDatumDefinitionName}</td>
                                            <td>{tagData.value}</td>
                                            <td>{format(tagData.tagDate, 'MMMM do yyyy, h:mm:ss a') || '-'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <NothingHere
                                loading={this.loading}
                                empty={!this.tagDatas?.length}
                                icon={<BsCardHeading />}
                            />
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }

    @bind
    @action
    public async loadTagData() {
        this.loading = true;

        try {
            await this.partsStore.loadPartTagDataAsync(this.props.partGuid);
        } catch (e: any) {
            this.appStore.setError(e);
        } finally {
            this.loading = false;
        }
    }

    @computed
    private get footer() {
        return <div />;
    }

    private title = (
        <span className="text-header fw-bold">
            <BsFileEarmark /> Part Tag Data
        </span>
    );

    @computed
    private get tagDatas() {
        const tagDatas = this.partsStore.partTagDatas.get(this.props.partGuid);
        return tagDatas?.slice().sort((a, b) => {
            return b.tagDate.valueOf() - a.tagDate.valueOf();
        });
    }

    @observable private loading = false;

    @inject private readonly partsStore!: PartsStore;
    @inject private appStore!: AppStore;
}
